angular.module('jv.deleteCandidate.controller', [])
    .controller('jvDeleteCandidateController', [
        '$scope', '$rootScope','$sessionStorage','TemplateLoader','jvCandidatesService','$window','$timeout','$location','jvHireBroadcastSVC',
        function($scope, $rootScope,$sessionStorage,TemplateLoader,jvCandidatesService,$window,$timeout,$location,jvHireBroadcastSVC) {
            var JV = $window.JV, i18n = $window.i18n;
            //notifications on successful delete
            var showNotification = function(value,isAnonymized) {
                var deleteMessage ;
                if(isAnonymized){
                    deleteMessage = 'CANDIDATES_ANNONYMIZED';
                } else {
                    deleteMessage = 'CANDIDATES_DELETED_SUCCESSFULLY';
                }

                if(value === 1 && !$scope.CandidateListPage){
                    $scope.showMsg(deleteMessage);
                }
                else{
                   $rootScope.$emit((isAnonymized ? 'ANONYMIZE_SUCCESSFUL' :'DELETE_SUCCESSFUL_MULTIPLE'), true);
                }

                 if(!$sessionStorage.appSearchFilters){
                     $window.location.href = $window.jvUrls.jhire + '/modules/candidates/search.html';
                 }
                 else {
                     $location.path('/q/return');
                 }

            };

            //Used to track if the user is on the candidate list page or details page
            $scope.CandidateListPage = false;
            $scope.CandidateDetailsPage = false;
            jvHireBroadcastSVC.subscribe('showDeleteCandidateModal', function(event, data) {
                $scope.modalData = angular.extend(data);
                /*The flag - deletePII is set to false for a gdpr disabled company, to display correct message on deletion of a candidate.
                Effect of this flag on functionality is zero*/
                $scope.modalData.deletePII = $scope.properties.isGdprEnabled? true : false;
                if($scope.modalData.appIds.length === 1){
                    $scope.modalData.name = data.name.firstName ? data.name.firstName+' '+data.name.lastName : data.name ;
                }
                if(!$scope.appDetails && !$scope.applicationId && JV.Person && JV.Person.Global){
                    JV.Person.Global.grid.showLoadingState();
                }
                $scope.CandidateDetailsPage = angular.isDefined($scope.params.applicationId);
                $scope.CandidateListPage = angular.isUndefined($scope.params.applicationId);
                var postData = {};
                postData.action = 'deleteCandidate';
                postData.data = data.appIds;
                jvCandidatesService.validateCandidateDetails(postData,function(response){
                    if(response && response.status === 200){
                        if(response.data.validApplicationIds.length === 0) {
                            var actionValidation = {};
                            actionValidation.show = true;
                            actionValidation.title = i18n.CANDIDATE_DELETE;
                            actionValidation.message = i18n.CANDIDATES_DELETE_PERMISSION_MSG;
                            $rootScope.$emit('actionValidation', actionValidation);
                            return;
                        }
                        $scope.modalData.validationResult = response.data;
                        $scope.modalData.appIds = response.data.validApplicationIds;
                        var bulkDelete = $scope.modalData.validationResult.validApplicationIds.length > 1 ? true : false;
                        $scope.modalData.validationResult.bulkDelete = bulkDelete;
                        var message = {};
                        message.text = $scope.modalData.validationResult.bulkDelete? i18n.CANDIDATES_BULK_DELETE_MSG: i18n.CANDIDATES_DELETE_MSG;
                        message.appendFirst = true;
                        $scope.modalData.validationResult.message = message;
                        $scope.showModals('deleteCandidate');
                    }
                });
            });
            if($.isEmptyObject($scope.i18n)){
                //Candidate list page does not have i18n
                i18n = {
                    REQUISITION: 'Requisition',
                    STATUS: 'Status',
                    COMPANY: 'Company',
                    CATEGORY: 'Category',
                    LOCATION: 'Location',
                    MOVE: 'Move',
                    SEARCH: 'Search',
                    ID: 'ID',
                    LIST_MODAL_TEXT: 'Select a Requisition',
                    ALL: 'All',
                    ADD: 'Add',
                    OPEN: 'Open',
                    MODAL_TOOLTIP_TEXT: 'Jobs listed are limited to active and those with the same workflow.',
                    MODAL_VALIDATION_TEXT: 'Please select a requisition'
                };
            }else{
                i18n = angular.copy($scope.i18n);
            }

            // Modal Information
            $scope.modals = {
                deleteCandidate: {
                    show: false
                }
            };
            //Used to show the move modal
            $scope.showModals = function(modal){
                TemplateLoader.load(modal).then(function(){
                        $scope.modals[modal].show = true;
                        if(JV.Person && JV.Person.Global){
                            JV.Person.Global.grid.removeLoadingState();
                        }
                });
            };

            //Used to hide all the modals on the page
            $scope.hideModals = function(){
                angular.forEach($scope.modals, function(val, key) {
                     $scope.modals[key].show = false;
                });
                if(JV.Person && JV.Person.Global){
                    JV.Person.resetValues();
                }
            };

            $scope.templates = TemplateLoader.register({
                deleteCandidate: '/jhire/modules/candidates/modals/deleteCandidate.html'
            });

            var removeLoadingState = function(){
                if($scope.CandidateListPage && JV.Person && JV.Person.Global){
                    JV.Person.Global.grid.removeLoadingState();
                }else{
                   $scope.flags.loading = false;
                }
            };
            //Delete Candidate
            $scope.deleteCandidate = function(gdprEnabled){
                $scope.flags.loading = true;
                jvCandidatesService.deleteCandidate($scope.modalData.appIds,gdprEnabled,$scope.modalData.deletePII, function(response){
                    $scope.flags.loading = false;
                    if(response && response.data && response.data.msgInfo === 200){
                        //Redirect to list page
                        $scope.hideModals();
                        showNotification(response.data.count,$scope.modalData.deletePII);
                    }else{
                        removeLoadingState();
                    }
                });
            };
        }
]);